var rolleLevel = {
  'Leserecht': 0,
  'Betreiber': 1,
  'Pruefer': 2,
  'Projektleiter': 3,
  'Admin': 4,
};

export default {
  computed: {
    dmRolle() {
      return this.$store.state.dm_rolle;
    },
    dmRolleLevel() {
      var rolle = this.$store.state.dm_rolle;
      if (typeof rolle === 'number') return rolle;
      return rolleLevel[rolle] !== undefined ? rolleLevel[rolle] : -1;
    },
    hasDmAccess() {
      return this.$store.state.dm_rolle !== null && this.$store.state.dm_rolle !== undefined;
    },
    canDmEdit() {
      return this.dmRolleLevel >= 2;
    },
    canDmManage() {
      return this.dmRolleLevel >= 3;
    },
    canDmAdmin() {
      return this.dmRolleLevel >= 4;
    },
    dmBerechtigungen() {
      return this.$store.state.dm_berechtigungen || {};
    },
  },
};
